import React from "react";

export interface TabPanelProps {
  children: React.ReactNode;
  isActive?: boolean;
}

export const TabPanel: React.FC<TabPanelProps> = ({ children, isActive }) => (
  <section
    role="tabpanel"
    className={`tabpanel ${isActive ? "active" : ""}`}
    hidden={!isActive}
  >
    {children}
  </section>
);

TabPanel.displayName = "TabPanel";